var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1489_11117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 2.5C5.44706 2.5 4.99935 2.94772 4.99935 3.5V5.83333H4.16602C2.79102 5.83333 1.66602 6.95833 1.66602 8.33333V13.1667C1.66602 13.719 2.11373 14.1667 2.66602 14.1667H4.99935V16.5C4.99935 17.0523 5.44706 17.5 5.99935 17.5H13.9993C14.5516 17.5 14.9993 17.0523 14.9993 16.5V14.1667H17.3327C17.885 14.1667 18.3327 13.719 18.3327 13.1667V8.33333C18.3327 6.95833 17.2077 5.83333 15.8327 5.83333H14.9993V3.5C14.9993 2.94771 14.5516 2.5 13.9993 2.5H5.99935ZM6.66602 4.16667H13.3327V5.83333H6.66602V4.16667ZM4.16602 7.5H15.8327C16.2927 7.5 16.666 7.87333 16.666 8.33333V12.5H14.9993V11.8333C14.9993 11.281 14.5516 10.8333 13.9993 10.8333H5.99935C5.44706 10.8333 4.99935 11.281 4.99935 11.8333V12.5H3.33268V8.33333C3.33268 7.87333 3.70602 7.5 4.16602 7.5ZM14.9993 8.33333C14.7783 8.33333 14.5664 8.42113 14.4101 8.57741C14.2538 8.73369 14.166 8.94565 14.166 9.16667C14.166 9.38768 14.2538 9.59964 14.4101 9.75592C14.5664 9.9122 14.7783 10 14.9993 10C15.2204 10 15.4323 9.9122 15.5886 9.75592C15.7449 9.59964 15.8327 9.38768 15.8327 9.16667C15.8327 8.94565 15.7449 8.73369 15.5886 8.57741C15.4323 8.42113 15.2204 8.33333 14.9993 8.33333ZM6.66602 12.5H13.3327V15.8333H6.66602V12.5Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1489_11117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.fb889000.svg";
export { ForwardRef as ReactComponent };